'use client'

import React, { useEffect, useRef } from 'react'
import styles from './Sidebar.module.scss'
import { useSidebar } from '@/context/SidebarContext'
import Icon from '@/components/Icon/Icon'

const SidebarClient = ({ id, children }: { id: string; children: React.ReactNode }) => {
  const { isOpen, close, goBackwards, currentHistory } = useSidebar()
  const contentRef = useRef<HTMLDivElement>(null)

  const open = isOpen(id)

  const backwards = (id: string) => {
    contentRef?.current?.scrollTo({ top: 0 })
    goBackwards(id)
  }

  useEffect(() => {
    if (open) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      if (scrollBarWidth > 0) {
        document.body.style.paddingRight = `${scrollBarWidth}px`
      }
    } else {
      document.body.style.overflow = ''
      document.body.style.paddingRight = '0'
    }
  }, [open])

  return (
    <div className={`${styles.overlay} ${open ? styles.open : ''}`}>
      <nav className={styles.panel}>
        <div className={styles.controls}>
          {currentHistory(id).length > 1 && (
            <button className={styles['back-btn']} aria-label="Zurück" onClick={() => backwards(id)}>
              <Icon name="arrowLeft" size={24} />
            </button>
          )}
          <button className={styles['close-btn']} aria-label="Schließen" onClick={() => close(id)}>
            <Icon name="close" size={24} />
          </button>
        </div>
        <div className={styles.content} ref={contentRef}>
          {children}
        </div>
      </nav>

      {open && <div className={styles.backdrop} onClick={() => close(id)} />}
    </div>
  )
}

export default SidebarClient
